import { createFileRoute } from "@tanstack/react-router";
import { BviManual } from "@/components/Compliance/Bvi/Manual";

export const Route = createFileRoute("/_authenticated/compliance/bvi/manual/")({
  component: BviManual,
  staticData: { page: "compliance" },
});
